import { useQuery } from "@tanstack/react-query";
import { scheduleAPI } from "../scheduleAPI.ts";

export const useGetScheduleQuery = () => {
  return useQuery ({
    queryKey: ["schedule"],
    queryFn: () => scheduleAPI.getSchedule(),
    staleTime: 15 * 60 * 1000, // 15мин
    gcTime: 60 * 60 * 1000, // 60мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
